<script setup>
import {useUserStore} from '@/stores/UserStore'
import TheSelect from '@shared-components/ui/selects/TheSelect.vue'
import {computed, ref, shallowRef} from 'vue'
import InputPreloader from '@shared-components/ui/inputs/InputPreloader.vue'
import {storeToRefs} from 'pinia'
import {useAuthenticationStore} from '@/stores'
import {openImpersonationTab} from '@shared-utils/auth/impersonation/helpers'

const {getImpersonationEmployees} = useUserStore()
const {user} = storeToRefs(useAuthenticationStore())
const {handleImpersonationToken} = useAuthenticationStore()

const loading = ref(false)
const loadingImpersonation = ref(false)
const userId = ref(user.value.id)
const users = shallowRef([])
const selectedUser = ref(null)
const usersOptions = computed(() => users.value?.map(({user_id, label}) => ({value: user_id, label: label})))

const init = async () => {
  loading.value = true
  try {
    users.value = await getImpersonationEmployees()
  } finally {
    loading.value = false
  }
}

const handleTriggerImpersonation = async id => {
  const user = users.value.find(item => item.user_id === id)
  if (!user) {
    return
  }

  const {token, origin} = await handleImpersonation(id)

  selectedUser.value = cloneSafe(user)
  userId.value = ''
  openImpersonationTab(token, origin)
}

const handleImpersonation = async id => {
  loadingImpersonation.value = true
  try {
    return await handleImpersonationToken(id)
  } finally {
    loadingImpersonation.value = false
  }
}

init()
</script>

<template>
  <input-preloader :show-preloader="loading || loadingImpersonation" name="users">
    <div class="w-240-px">
      <the-select
        :options="usersOptions"
        :model-value="userId"
        @change="handleTriggerImpersonation"
        :allow_clear="false"
        :can_deselect="false"
        no-results-text="Company not found. It may be inactive. Add at least 1 user to activate it."
      />
    </div>
  </input-preloader>
</template>

<style lang="scss" scoped>
:deep(.multiselect-dropdown:has(.multiselect-no-results)) {
  max-width: 100%;
}

:deep(.multiselect-no-results) {
  padding: 0.75rem 1rem;
  color: #6b7280;
  white-space: normal;
}
</style>
